<template>
  <div class="flex flex-col gap-4">
    <!-- Header -->
    <TextHeader class="border-none pb-0!">Documenten</TextHeader>
    <TabsComponent :tabs />
    <RouterView />
  </div>
</template>

<script setup>
import { TextHeader } from "@repowerednl/ui-component-library"
import TabsComponent from "@/components/navigation/TabsComponent.vue"

const tabs = [
  {
    name: "Facturen",
    route: "documents-invoices",
  },
  {
    name: "Exports",
    route: "documents-exports",
  },
]
</script>
